// extracted by mini-css-extract-plugin
export default {"wrapper":"Why_wrapper__NCNT6","signatures":"Why_signatures__2K6k9","imagebutton":"Why_imagebutton__Pe7Ml"};